import React, { FC, useMemo } from "react";
import './JCommunicationText.scss';

export interface JCommunicationTextProps {
    color?: string,
    backgroundColor?: string,
    container?: 'fluid' | 'contained'
    text?: string
}

export const JCommunicationText: FC<JCommunicationTextProps> = props => {
    if (!props?.text) return <span></span>
    const container = useMemo(() => props?.container || 'fluid', [props?.container])
    return (
        <div
            className={`jcommunicationtext jcommunicationtext-container-${container}`}
            style={{
                color: props.color || "#FFF",
                backgroundColor: props.backgroundColor || "#FFF",

            }}>
            {
                props?.text 
            }
        </div>
    );
};

